// PostHog project (public) key — safe in client code. Override via env if set.
export const POSTHOG_KEY =
  process.env.GATSBY_POSTHOG_KEY || "phc_w4aEsqxxc2kQQNGR6DHMgrWiZdsBtrF67KJJMHndAEmu";
export const POSTHOG_HOST = process.env.GATSBY_POSTHOG_HOST || "https://eu.i.posthog.com";
